export enum AutomationClauseType {
  QUICK_AI = 'bulk_tagging',
  GUIDED_AI = 'smart_clause',
}
